angular.module('autoremind.dashboard.constants', [])
    .constant('PLUGINS', (function () {
    return {
        widgetsConfig: {
            resellerPayingCustomers: {
                class: 'col-md-8',
                directive: 'reseller-paying-customers',
                headerIcon: 'dollar.png'
            },
            resellerWidget: {
                class: 'col-md-4',
                directive: 'reseller-widget',
                headerIcon: 'multi-agents.png'
            },
            resellerInTrial: {
                class: 'col-md-4',
                directive: 'reseller-in-trial',
                headerIcon: 'configuration.png'
            },
            messagesSentToday: {
                class: 'col-md-4',
                directive: 'messaging',
                headerIcon: 'pie-chart.png'
            },
            recallsInProgress: {
                class: 'col-md-8',
                directive: 'recalls-widget',
                headerIcon: 'pie-chart.png'
            },
            missedInProgress: {
                class: 'col-md-6',
                directive: 'missed-widget',
                headerIcon: 'pie-chart.png'
            },
            birthdayWasToday: {
                class: 'col-md-6',
                directive: 'birthday-widget',
                headerIcon: 'pie-chart.png'
            },
            support: {
                class: 'col-md-3',
                directive: 'support-widget',
                headerIcon: 'pie-chart.png'
            },
            news: {
                class: 'col-md-3',
                directive: 'news-widget',
                headerIcon: 'pie-chart.png'
            }
        },
        widgetsConfigDefault: {
            headerIcon: 'pie-chart.png'
        }
    };
})());
//# sourceMappingURL=dashboard.constants.js.map